import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

const safeSelector = (state: RootState) => state.integrations;
export const integrationsLoadingSelector = createSelector(safeSelector, (state) => state.loading);
export const integrationsErrorSelector = createSelector(safeSelector, (state) => state.error);
export const organizationSelector = createSelector(safeSelector, (state) => state.organization);
export const disconnectingSelector = createSelector(safeSelector, (state) => state.disconnecting);
export const connectionIntegrationSelector = createSelector(
  safeSelector,
  (state) => state.connecting
);
